import axios from "@/repositories/client";
import default_group from "@/defaults/default-group";

axios.getHotelGroups = (query, pagination, args) => {

  let dropdown = args.dropdown || false;

  let options = {
    params: {
      search: query,
      skip: pagination.size * (pagination.page - 1),
      take: pagination.size
    }
  };

  return axios.get(`athena/v1/hotel-groups`, options)
    .then(response => {
      if(dropdown)
        return response.data.data.map(group => ({text: group.name, value: group.id}));

      return response.data;
    });
};

axios.getHotelGroup = (group) => {

  if (group === 'create')
    return new Promise((resolve => {
      resolve(_.cloneDeep(default_group));
    }));

  return axios.get(`athena/v1/hotel-groups/${group}`)
    .then(response => {
      return response.data.data;
    });
};

axios.saveHotelGroup = (hotel) => {
  let url = `athena/v1/hotel-groups` + (hotel.id ? `/${hotel.id}` : '');
  let verb = hotel.id ? 'PUT' : 'POST';

  return axios.request({method: verb, url: url, data: hotel})
    .then(response => {
      return response.data.data;
    });
};

axios.destroyHotelGroup = (group) => {
  return axios.delete(`athena/v1/hotel-groups/${group.id}`)
    .then(response => {
      return response.data;
    });
};

export default axios;